import { render, staticRenderFns } from "./SlipStitchIcon.vue?vue&type=template&id=6d8f1450&scoped=true"
import script from "./SlipStitchIcon.vue?vue&type=script&lang=js"
export * from "./SlipStitchIcon.vue?vue&type=script&lang=js"
import style0 from "./SlipStitchIcon.vue?vue&type=style&index=0&id=6d8f1450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f1450",
  null
  
)

export default component.exports